import { render, staticRenderFns } from "./UserSingle.vue?vue&type=template&id=736ecef8"
import script from "./UserSingle.vue?vue&type=script&lang=js"
export * from "./UserSingle.vue?vue&type=script&lang=js"
import style0 from "./UserSingle.vue?vue&type=style&index=0&id=736ecef8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports